import React, { useState } from "react";
import styled from "styled-components";
import { TextMenu, TextSelection } from "common/components";
import { colors } from "common/const/colors";
import { CheckIcon, FixedIcon, IconWrapper } from "common/components/icon";

const boxSizes = {
  // small: "0.875rem",
  medium: "1rem",
  large: "1.125rem",
};

const textBySize = {
  // small: TextBadge,
  medium: TextMenu,
  large: TextSelection,
};

const StyledCheckboxOption = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem;
  cursor: ${({ $interactive }) => ($interactive ? "pointer" : "not-allowed")};
  color: ${({ $disabled }) => ($disabled ? colors.Gray : colors.DarkNavy)};
`;

const StyledCheckbox = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ size }) => boxSizes[size]};
  height: ${({ size }) => boxSizes[size]};
  border-radius: 0.25rem;
  box-sizing: border-box;

  background-color: ${({ $checked, $fixed, $disabled }) => {
    if ($disabled) return $checked || $fixed ? colors.LightNavy : "transparent";
    return $checked || $fixed ? colors.MainBlue : colors.White;
  }};

  border: ${({ $checked, $disabled }) =>
    $checked
      ? "none"
      : `1px solid ${$disabled ? colors.Gray : colors.LightNavy}`};
`;

export const CheckboxItem = ({
  label,
  value,
  checked,
  onToggle,
  size = "medium",
  fixed = false,
  disabled = false,
}) => {
  const Label = textBySize[size] || TextMenu;
  const isControlled =
    typeof checked === "boolean" && typeof onToggle === "function";
  const [internalChecked, setInternalChecked] = useState(false);

  const isChecked = fixed || (isControlled ? checked : internalChecked);
  const canInteract = !disabled && !fixed;

  const handleClick = () => {
    if (!canInteract) return;
    isControlled ? onToggle(value) : setInternalChecked((prev) => !prev);
  };

  return (
    <StyledCheckboxOption
      onClick={handleClick}
      role="checkbox"
      aria-checked={isChecked}
      aria-disabled={!canInteract}
      $disabled={disabled}
      $interactive={canInteract}>
      <StyledCheckbox
        size={size}
        $checked={isChecked}
        $fixed={fixed}
        $disabled={disabled}>
        <IconWrapper size="0.75rem">
          {fixed ? (
            <FixedIcon strokeWidth={1.5} color="white" />
          ) : isChecked ? (
            <CheckIcon strokeWidth="3px" color="white" />
          ) : null}
        </IconWrapper>
      </StyledCheckbox>
      <Label>{label}</Label>
    </StyledCheckboxOption>
  );
};
